import {
  EPublishTermsAvailableMoneySources,
  EPublishTermsStatus,
  IPublication,
  IPublishTermsServices,
  IPublishTermsState,
} from '../../types/reducers/publishTerms';

const publication: IPublication = {
  period: null,
};

export const publishTermsDefaultState: IPublishTermsState = {
  autoProlong: true,
  status: EPublishTermsStatus.initial,
  isServicesReloading: false,
  services: {} as IPublishTermsServices,
  serviceIds: [],
  selectedServiceId: null,
  promotionServiceId: null,
  message: null,
  error: null,
  isMultipostingAvailable: false,
  multipostingABGroup: null,
  packages: {},
  packageIds: [],
  selectedPackageId: null,
  periodsByService: {},
  selectedPeriodId: null,
  selectedPlacingType: null,
  isPlacingTypeChangedByUser: false,
  publication,
  moneySource: null,
  isServicesEnabled: true,
  availableMoneySources: EPublishTermsAvailableMoneySources.MasterAndSelf,
  highDemandCoefficient: null,
  promotionTypeChangeReason: null,
};
